// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"74c64a11","277":"e1adedbb","437":"6cb7acda","605":"87f23d01","615":"27b04996","754":"a64e5304","818":"8b6f6631","917":"2a10e2c0","936":"d0c297a1"}[chunkId] + ".chunk.js";
};